module.exports = __webpack_public_path__ + "img/Bell_01.c58106e3.png";